import { resolveActiveFlag } from '../service/mappers/map-fact-trajectory';
import type { TTrajectory } from '../types/trajectory';

type TActiveLike = Pick<TTrajectory, 'active' | 'definitive' | 'activeStatus'>;

export function isTrajectoryActiveFlag(item: TActiveLike): boolean {
  return resolveActiveFlag(item) === true;
}

/** Prefer an active item; otherwise the first in the list. */
export function pickActiveOrFirst<T extends TActiveLike>(items: readonly T[]): T | null {
  if (items.length === 0) {
    return null;
  }

  return items.find((item) => isTrajectoryActiveFlag(item)) ?? items[0] ?? null;
}
